import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownMenuGroup, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useMenuActions, MenuActionItem } from '@/features/user-menu';

export function MenuContent() {
  const { t } = useTranslation();
  const { actions } = useMenuActions();

  return (
    <>
      <DropdownMenuLabel>{t('userMenu.myAccount', 'My account')}</DropdownMenuLabel>
      <DropdownMenuSeparator />

      <DropdownMenuGroup>
        {actions.map((action) => (
          <Fragment key={action.id}>
            {action.separator === 'before' && <DropdownMenuSeparator />}
            <MenuActionItem action={action} />
            {action.separator === 'after' && <DropdownMenuSeparator />}
          </Fragment>
        ))}
      </DropdownMenuGroup>
    </>
  );
}
